var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{attrs:{"span":24}},[_c('span',[_c('span',{staticClass:"font-size__small"},[_vm._v(_vm._s(_vm.fieldTitle)+":")]),_vm._v(" "),_c('break-word-span',{staticClass:"font-weight__bold",attrs:{"text":_vm.value || '-',"maxLength":100}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdf680de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/vemaybay/hc-maybay-user-route-extend-info-item.vue
// module id = null
// module chunks = 